import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tableList, tabsList, tHallPolicyFileAllRead } from "@/api/portrayal/policy";
import { getUser } from "@/api/management/user";
import { stuAndteachStastic } from "@/api/home/home";
import { getNoticeList, allRead } from "@/api/managementCenter/notification";
import { remote } from "@/api/admin/dict";
import TreeSelect from "@/components/TreeSelect.vue";
import { getDeptTree } from "@/api/managementCenter/otherApi";
import { mapActions } from "vuex";
export default {
  name: "noticesAndFilesPagination",
  data: function data() {
    return {
      loading: false,
      noticeTypeList: [],
      fileTypeList: [],
      departmentData: [],
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      },
      noticeSearch: {
        deptName: "",
        noticeType: "",
        name: ""
      },
      fileSearch: {
        type: "",
        keywords: ""
      },
      list: [],
      current: 1,
      size: 20,
      total: 0,
      type: "",
      title: ""
    };
  },
  components: {
    TreeSelect: TreeSelect
  },
  computed: {},
  watch: {},
  created: function created() {
    this.type = this.$route.query.type;
    this.title = this.type === "file" ? "校内公文" : this.type === "3" ? "规章制度" : this.type === "4" ? "业务流程" : this.type === "5" ? "常用下载" : "通知公告";
    this.noticeSearch.noticeType = this.type == "notice" ? "0" : this.type;
    this.initList();
    this.remoteFn();

    if (this.type === "file") {
      this.typeOption();
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions(["GetUnreadCount"])), {}, {
    initList: function initList() {
      this.current = 1;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      if (this.type === "business") {
        var type;
        var userId = this.$store.getters.userData.userId;
        getUser(userId).then(function (res) {
          type = res.data.data.type;
          stuAndteachStastic().then(function (res) {
            if (type == 1) {
              _this.list = res.data.data.teacher;
            } else {
              _this.list = res.data.data.stu;
            }
          });
        });
      }

      var rq = this.type === "file" ? tableList : getNoticeList;
      var pageSeahparams = {
        current: this.current,
        size: this.size
      };
      var params = this.type === "file" ? _objectSpread(_objectSpread({}, this.fileSearch), pageSeahparams) : _objectSpread(_objectSpread({}, this.noticeSearch), pageSeahparams);
      this.loading = true;
      rq(params).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.list = data.data.records;
          _this.total = data.data.total;
        } else {
          _this.$message.error(data.msg);
        }
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    changePage: function changePage(page) {
      this.current = page;
      this.getList();
    },
    viewDetail: function viewDetail(item) {
      var path = this.type === "file" ? "/fileDetail" : "/notifyDetail";
      var routeData = this.$router.resolve({
        name: path,
        query: {
          id: item.id,
          fileId: item.fileId || "",
          type: item.type || ""
        }
      });
      window.open(routeData.href);
    },
    //获取类型
    remoteFn: function remoteFn() {
      var _this2 = this;

      remote("notice_type").then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this2.noticeTypeList = data.data || [];
        } else {
          _this2.$message.warning(data.msg || "获取类型失败!");
        }
      }).catch(function (err) {
        _this2.$message.error(data.msg || "获取类型异常!");
      });
    },
    //获取部门数据
    getDeptTreeData: function getDeptTreeData() {
      var _this3 = this;

      getDeptTree().then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          if (data.data && data.data.length > 0) {
            if (data.data[0].id == 1) {
              _this3.departmentData = data.data[0].children;
            } else {
              _this3.departmentData = data.data;
            }
          }
        }
      }).catch(function (err) {});
    },
    setDeptSingleMenu: function setDeptSingleMenu(key, data) {
      //获取子组件值
      this.noticeSearch.curDeptId = data.id;
    },
    allReadFn: function allReadFn() {
      var _this4 = this;

      var method = null;

      if (this.type === "notice") {
        method = allRead;
      }

      if (this.type === "file") {
        method = tHallPolicyFileAllRead;
      }

      method().then(function (_ref4) {
        var data = _ref4.data;

        if (data.code == 0) {
          _this4.$message.success("操作成功!");

          _this4.getList();

          _this4.GetUnreadCount();
        } else {
          _this4.$message.warning(data.msg || "操作失败!");
        }
      }).catch(function (err) {
        _this4.$message.error("服务异常!");
      });
    },
    typeOption: function typeOption() {
      var _this5 = this;

      tabsList("/admin/dict/type/policy_type").then(function (res) {
        if (res.data.code == 0) {
          _this5.fileTypeList = res.data.data || [];
        }
      });
    }
  }),
  filters: {
    readFlagFilter: function readFlagFilter(value) {
      var obj = {
        0: "未读",
        1: "已读"
      };
      return obj[value + ""] || "";
    }
  }
};